import { cn } from "../../utils/cn";

const TextInputPermitPDF: React.FC<{
    label: string;
    value: string;
    labelStyles?: string;
    valueStyles?: string;
    styles?: string;
    width?: string;
    height?: string;
}> = ({
    label,
    value,
    width = "w-full",
    height = "h-7",
    styles,
    labelStyles,
    valueStyles,
}) => (
        <div className={cn("flex w-full", width, height, styles)}>
            <div
                className={cn(
                    " border-black px-1.5 text-[10px] flex items-center",
                    labelStyles
                )}
            >
                {label}
            </div>
            <div
                className={cn(
                    " border-black px-1.5 text-[10px] flex items-center",
                    valueStyles
                )}
            >
                {value}
            </div>
        </div>
    );

export default TextInputPermitPDF;